import { isMobileOperatingSystem } from '@repo/detection';

// This is a feature flag migrated outside of growthbook on rollout
// Deployed to serve true by default if not on mobile, kept here due to the conditional check
export const aiCopilotIsOn = (): boolean => !isMobileOperatingSystem();

const useIsAiCopilotEnabled = (): boolean => {
  return aiCopilotIsOn();
};

export default useIsAiCopilotEnabled;
